import { useState, ReactNode } from 'react';
import { ErrorBoundary, MainBoundary } from '@frontend/error-boundary';
import { theme } from '@frontend/theme';

export const Section = ({
  children,
  render,
  className,
}: {
  children?: ReactNode;
  render?: (setShouldHide: (val: boolean) => void) => ReactNode;
  className?: string;
}) => {
  const [shouldHide, setShouldHide] = useState(false);
  const content = render ? render(setShouldHide) : children;
  return (
    <ErrorBoundary fallback={MainBoundary}>
      {!shouldHide && (
        <section
          css={{
            width: '100%',
            padding: theme.spacing(3),
            '&:not(:first-of-type)': {
              borderTop: `1px solid ${theme.colors.neutral10}`,
            },
          }}
          className={className}
        >
          {content}
        </section>
      )}
    </ErrorBoundary>
  );
};
